import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import EventPage from './components/wedding/Events/EventPage'
import CreateEvent from './components/wedding/Events/CreateEvent'
import UpdateEvent from './components/wedding/Events/UpdateEvent'
import store from './redux/store'
import { loadUser } from './redux/reducers/authSlice';
import "bootstrap/dist/css/bootstrap.min.css"
import '../node_modules/bootstrap/dist/js/bootstrap.bundle'
import FormContainer from './components/wedding/Forms/FormContainer'
import ProtectedRoute from './components/helpers/ProtectedRoute'
// import Setting from './components/wedding/settings/Setting'
import Display from './components/helpers/Display'
import Landing from './components/wedding/Landing'
// import EndHome from './components/wedding/EndInvite/EndHome'
import Notfound from './components/helpers/Notfound'
// import CreateLink from './components/wedding/EndInvite/CreateLink'
// import Appreance from './components/wedding/EndInvite/Appreance'
// import FinalHome from './components/wedding/FinalOutput/FinalHome'
import { useLocation } from 'react-router-dom';
// import Tac from './components/helpers/Tac'
// import ImageAlbum from './components/wedding/Forms/ImageAlbum'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
// import Demohomepage from './components/wedding/Forms/Demohomepage'
// import TrialPage from './components/wedding/Forms/TrialPage'
// import Otpparent from './components/wedding/DemoTrial/Otpparent'
// import PreviewHome from './components/wedding/FinalOutput/PreviewHome'
// import Tempfinal from './components/wedding/FinalOutput/Tempfinal'
import Privarypolicy from './components/helpers/Privarypolicy'
import Termscon from './components/helpers/Termscon'
import Refund from './components/helpers/Refund'
// import NewFinalOutput from './components/wedding/FinalOutput/NewFinalOutput'
import ThemeRenderer from './components/wedding/ThemeRenderer'
import PreviewForm from './components/wedding/Forms/PreviewForm'
import ShareForm from './components/wedding/Forms/ShareForm'
import FreeTrial from './components/authentication/FreeTrial'
import Loginflow from './components/authentication/Loginflow'
import Demoexpired from './components/helpers/Demoexpired'
import ThemeCollection from './components/wedding/ThemeCollection'
import SamplePage from './components/wedding/FinalOutput/SamplePage'

const App = () => {
  const location = useLocation()
  const isAlphanumeric = /^[A-Za-z0-9]{9}$/.test(location.pathname.substr(1));
  const isExcludedPath = [
    '/signup/',
    '/login',
    '/password/reset/',
    '/display/',
    '/trial/expired',
     '/terms-and-conditions',
    '/privacy-policy',
    '/refund-and-cancellations',
    '/free-trial',
    '/demo',
     '/sample'
  ].some(path => location.pathname.startsWith(path));

  useEffect(() => {
    if (!isAlphanumeric && !isExcludedPath) {
      store.dispatch(loadUser());
    }

  }, [location.pathname])

  useEffect(() => {
    AOS.init({
      // Configuration options here
      duration: 1000, // Duration of animations in milliseconds
      easing: 'ease-in-out', // Easing for animations
      once: true, // Animation occurs only once
    });
  }, []);

  return (
//jab bhi new comp banana hoon agar useffect mai request call ho rhi hai to protectedroute mai nhi dalna
    
    <Routes>
      <Route path='/' element={<ProtectedRoute />} >
        <Route index element={<Landing />} />
      </Route>
      <Route path='/details' element={<FormContainer />}></Route>
      <Route path='/events' element={<EventPage />}></Route>
      <Route
        path="/event/new"
        element={<ProtectedRoute />} >
        <Route index element={<CreateEvent />} />
      </Route>
      <Route path="/event/:id" element={<UpdateEvent />} />
      {/* <Route
        path="/settings"
        element={<ProtectedRoute />}>
        <Route index element={<Setting />} />
      </Route> */}
      {/* <Route path='/private/preview/:usercode' element={<PreviewHome/>} /> */}
      <Route path='/preview'  element={<PreviewForm/>} />
       <Route path='/share'  element={<ShareForm/>} />
      {/* <Route
        path="/endinvitation"
        element={<ProtectedRoute />}>
        <Route index element={<EndHome />} />
      </Route> */}
      {/* <Route path='/links' element={<CreateLink />} />
      <Route path='/appreances' element={<Appreance />} /> */}
      {/* <Route path='/signup/:id' element={<Signup />} />
      <Route path='/signup/:id/date' element={<DateComponent/>}  /> */}
      {/* <Route path='/free-trial' element={<Otpparent />} /> */}
      <Route path="/free-trial"  element={<FreeTrial/>}  />
      {/* <Route path='/login' element={<Switching />} /> */}
      <Route path='/login' element={<Loginflow /> } />
      {/* <Route path='/password/reset/:token' element={<ResetPassword />} /> */}
      <Route path='/display/:screen' element={<Display />} />
      <Route path='/trial/expired' element={<Demoexpired />} />
      {/* <Route path='/demo-wedding-invitation' element={<Demohomepage/>} /> */}
      <Route path='/sample-themes' element={<ThemeCollection/>} />
      {/* <Route path='/terms-and-condition' element={<Tac/>}  /> */}
       <Route path='/privacy-policy' element={<Privarypolicy/>}  />
        <Route path='/terms-and-conditions' element={<Termscon/>}  />
           <Route path='/refund-and-cancellations' element={<Refund/>}  />
       {/* <Route path='/checking' element={<Tempfinal/>}  /> */}
                    <Route path='/preview/:userId' element={<ThemeRenderer  mode="preview" />}  />
             <Route path='/:userId' element={<ThemeRenderer  mode="public" />}  />
      {/* <Route path='/:username' element={<FinalHome />} /> */}
      {/* <Route path='/demo-wedding-invitation' element={<ProtectedRoute />} >
        <Route index element={<Demohomepage />} />
      </Route> */}
      {/* <Route path='/preview/:theme'  element=<TrialPage/>  /> */}
     <Route path='/demo/:userId'   element=<SamplePage  mode="private" />  />
      <Route path='/sample/:userId'   element=<SamplePage  mode="public" />  />
      <Route path="*" element={<Notfound />} />
    </Routes>

  )
}

export default App